import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("Service Worker registered", reg);
        
        // Check for updates every 60 seconds
        setInterval(() => {
          reg.update();
        }, 60000);

        // Listen for updates
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          console.log("New Service Worker found, installing...");
          
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              // New service worker available, refresh the page
              console.log("New Service Worker installed, reloading page...");
              window.location.reload();
            }
          });
        });
      })
      .catch((err) => console.log("Service Worker registration failed", err));
  });

  // Listen for controller change (when new SW takes control)
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    console.log("Service Worker controller changed, reloading...");
    window.location.reload();
  });
}
